<template lang="pug">
  BaseTable(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :table="table"
    :items="items"
    :meta="meta"
    :sort="sort"
    :page="page"
    :onDelete="onDelete"
    :toggleSort="toggleSort"
    :changePage="changePage"
  )
</template>

<script>
import BaseTable from '@/components/app/BaseTable'
import store from '@/store'
import { mapState, mapMutations } from 'vuex'

export default {
  components: { BaseTable },
  data: vm => ({
    title: vm.$t('rappers.title')
  }),
  computed: {
    ...mapState('rappers', ['routeKey', 'routes', 'table', 'items', 'meta', 'sort', 'page']),
    crumbs: vm => [
      { text: vm.$t('rappers.title') }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('rappers/fetchItems')
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapMutations('rappers', ['SET_SORT', 'SET_PAGE']),
    async onDelete (id) {
      await store.dispatch('rappers/deleteItem', { id })
      await store.dispatch('rappers/fetchItems')
      this.$notify({ message: this.$t('forms.notify.deleted') })
    },
    async toggleSort (field) {
      this.SET_SORT(field)
      await store.dispatch('rappers/fetchItems')
    },
    async changePage (page) {
      this.SET_PAGE(page)
      await store.dispatch('rappers/fetchItems')
    }
  }
}
</script>
